import { CSSProperties, useEffect, useState } from "react";
import Colors from "modules/Colors";
import { styx } from "modules/Utils";

interface LoadingBarProps {
    message?: string;
    percentage?: number;
}

const LoadingBar = ({
    message = 'Loading...',
    percentage: percentageProp = 0,
}: LoadingBarProps) => {
    const [internalPercentage, setInternalPercentage] = useState(percentageProp)

    useEffect(() => {
        const interval = setInterval(() => {
            setInternalPercentage(prev => {
                const next = prev + 1
                return next >= 100 ? 0 : next
            })
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    return (
        <div
            className="loadingBarElement"
            style={sty.loadingBarElement}
        >
            <div className="loadingBarMessage" style={sty.loadingBarMessage}>
                {message}
            </div>
            <div className="loadingBarContainer" style={sty.loadingBarContainer}>
                <div
                    className="loadingBarFill"
                    style={styx(sty.loadingBarFill, {
                        width: `${internalPercentage}%`
                    })}
                />
            </div>
            <div className="loadingBarPercentage" style={sty.loadingBarPercentage}>
                {internalPercentage}%
            </div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    loadingBarElement: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
    },
    loadingBarMessage: {
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'nowrap',
    },
    loadingBarContainer: {
        width: '100%',
        height: 16,
        backgroundColor: Colors.greyLight,
        borderRadius: 100,
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    loadingBarFill: {
        height: 16,
        backgroundColor: Colors.purpleLight,
        borderRadius: 100,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'width 0.3s ease-in-out'
    },
    loadingBarPercentage: {
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'nowrap',
    }
}

export default LoadingBar;